import { useState } from "react";

import Image from "next/image";

import { IUserLevel } from "pages/[tenant]/g/@types";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { useFeature } from "shared/utils/hooks/useFeature";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { UserLevelContainer } from "./styles";

interface IUserLevelProps {
  level: Omit<IUserLevel, "id">;
  show?: boolean;
  className?: string;
  size: number;
  forceShow?: boolean;
}

export const UserLevel = ({
  level,
  show,
  className = "",
  size,
  forceShow,
}: IUserLevelProps) => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  const {
    state: { tenancy },
  } = useGlobalContext();

  const isUserLevelBadgeEnabled =
    tenancy?.settings?.gamification?.showLevelOnProfile == 1;

  const isLevelsEnabled = useFeature("f_levels");

  const shouldShowImage = !imageFailedToLoad && !!level?.seal_image;
  const shouldRender =
    ((!!level?.title && isUserLevelBadgeEnabled) || show) &&
    isLevelsEnabled &&
    shouldShowImage;

  if (!shouldRender && !forceShow) return null;
  return (
    <UserLevelContainer title={level?.title} className={className}>
      <ComponentErrorBoundary fallback={<></>}>
        <Image
          alt=""
          src={level?.seal_image}
          width={size}
          height={size}
          onError={() => setImageFailedToLoad(true)}
        />
      </ComponentErrorBoundary>
    </UserLevelContainer>
  );
};
